import { useEffect, useState } from "react";
import { parseCSV } from "utils/csvParser";
import { getUrl } from "hooks/useSatismeterAnswers";
import config from 'utils/siteConfig';

const SHEET_RATING_TITLE = 'RatingSheet';
const SHEET_RATING_RANGE = 'A:B'

export const useSatismeterScore = () => {
  const [ratingValue, setRatingValue] = useState(config.ratingValue);
  const [ratingCount, setRatingCount] = useState(config.ratingCount);


  const fetchRating = async () => {
    fetch(getUrl(SHEET_RATING_TITLE, SHEET_RATING_RANGE))
      .then(res => res.text())
      .then(rep => {
        const data = parseCSV(rep)
        // data from sheet is an array of array of string + we want to display the average rating out of 5
        const value = Number(data[1][0] / 2);
        setRatingValue(Math.round(value * 10) / 10);
        setRatingCount(Number(data[1][1]));
      })
      .catch((e) => {
        console.error(e);
      })
  }

  const reload = () => {
    fetchRating();
  }

  useEffect(() => {
    fetchRating();
  }, []);

  return { ratingValue, ratingCount, maxRating: 5, reload }
}

